import { create } from 'zustand';

interface HistoryStoreType {
  history: string[];
  lastPushedPathname: string | null;
  push: (newEntry: string) => void;
  pop: () => void;
  replace: (newEntry: string) => void;
  setLastPushedPathname: (url: string | null) => void;
}

export const useHistoryStore = create<HistoryStoreType>((set) => ({
  history: [],
  lastPushedPathname: null,
  push: (url) =>
    set((state) => {
      if (state.history[state.history.length - 1] === url) {
        return state;
      }
      return { history: [...state.history, url], lastPushedUrl: url };
    }),
  pop: () =>
    set((state) => ({
      history: state.history.slice(0, -1),
      lastPushedUrl: state.history[state.history.length - 2] || null,
    })),
  replace: (url) =>
    set((state) => {
      if (state.history[state.history.length - 1] === url) {
        return state;
      }
      const newHistory = state.history.slice(0, -1);
      return { history: [...newHistory, url], lastPushedUrl: url };
    }),
  setLastPushedPathname: (url) => set({ lastPushedPathname: url }),
}));
